import {
    asyncRouterMap,
    constantRouterMap,
} from '@/router/index';

/**
 * 通过route.name判断是否与当前用户权限匹配
 * @param userMenuTree
 * @param route
 */
function hasPermission(nodeList, name) {
    return nodeList.some((node) => {
        // 有一级栏目就默认注册该栏目下的index页面
        if (node.name === name || `${node.name}Index` === name) return true;
        return hasPermission(node.children || [], name);
    });
}

/**
 * 过滤异步路由表，返回符合用户菜单权限的路由表
 * @param asyncRouterMap
 * @param userMenuTree
 */
function filterAsyncRouter(asyncRouter, userMenuTree) {
    const accessedRouters = asyncRouter.filter((route) => {
        // 白名单路由
        if (route.permission) return true;
        if (hasPermission(userMenuTree, route.name)) {
            // 递归各栏目下子级页面
            if (route.children && route.children.length) route.children = filterAsyncRouter(route.children, userMenuTree);
            return true;
        }
        return false;
    });

    return accessedRouters;
}

const permission = {
    name: 'permission',
    namespaced: true,
    state: {
        routers: constantRouterMap,
        addRouters: [],
    },
    actions: {
        GenerateRoutes({ commit, rootState }) {
            const { userMenuTree } = rootState.user;
            const accessedRouters = filterAsyncRouter(asyncRouterMap.children, userMenuTree);
            asyncRouterMap.children = accessedRouters;
            const addRouters = [
                asyncRouterMap,
                // 最后追加404
                { path: '*', redirect: '/404' },
            ];

            commit('SET_STATE', {
                addRouters,
                routers: [
                    ...constantRouterMap,
                    ...addRouters,
                ],
            });
        },
    },
};

export default permission;
